var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.length)?_c('div',{staticClass:"c-detail-ad"},_vm._l((_vm.list),function(ad){return _c('a',{key:ad.id,staticClass:"item",attrs:{"href":ad.data.link}},[_c('div',{staticClass:"img",style:({'background-image': `url(${ad.data.image})`})})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }